/* istanbul ignore file */
import React from 'react';
import { Box, Paper } from '@mui/material';
import { getVisibility } from 'framework/utils';
import SendEmailHeader from 'infrastructure/email/sendEmail/shared/SendEmailHeader';
import { useShowContext } from 'framework/show';
import { pageContentSx } from 'framework/ui/layout';

const MAIL_PREVIEW_SX = {
  border: '1px solid',
  borderColor: 'border.default',
  padding: '40px',
  position: 'relative',
  margin: '20px 0',
  '&::before': {
    content: '"Preview"',
    position: 'absolute',
    top: '-1.1em',
    backgroundColor: 'common.white',
    display: 'block',
    padding: '5px 10px',
    fontWeight: 700,
  },
};

type SendFormPageLayoutProps = {
  buttons?: React.ReactElement[];
  children: React.ReactElement | React.ReactElement[];
};

const SendFormPageLayout = ({ buttons, children }: SendFormPageLayoutProps) => {
  const { data } = useShowContext();
  const taskName = data.getValueBySource('taskName') || {};

  return (
    <Paper sx={pageContentSx}>
      <SendEmailHeader taskName={taskName} />

      {data ? (
        <div className="list-page-top-block">
          <Box component="section" sx={MAIL_PREVIEW_SX}>
            {React.Children.map(children, child => {
              const { isVisible: isVisibleProp } = child.props;

              const isVisible = getVisibility(data, isVisibleProp);

              return isVisible ? child : null;
            })}
          </Box>
          {buttons &&
            buttons.map((button: React.ReactElement) => {
              const { isVisible: isVisibleProp } = button.props;

              const isVisible = getVisibility(data, isVisibleProp);

              return isVisible ? button : null;
            })}
        </div>
      ) : null}
    </Paper>
  );
};

export default SendFormPageLayout;
